import {MApartHoverCard} from "@/pages/common/Home/Overview/ApartHoverCard";
import {Try} from "@/pages/common/Home/components/Try";

import React from "react";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {PresentationPopup} from "@popups/requestPopups/PresentationPopup";
import {BorderArticle} from "@ui/general/BorderArticle";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {opacity: 0},
  visible: (custom) => ({
    opacity: 1,
    transition: {
      delay: custom * 0.3,
    },
  }),
};

export const Apart = () => {
  const {t} = useTranslation();
  const {isMobile} = useSelector((state) => state.common.settings);

  const list = [
    {
      id: 0,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.desc_1"),
          }}
        />
      ),
      icon: "tailored",
    },
    {
      id: 1,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.desc_2"),
          }}
        />
      ),
      icon: "lms",
    },
    {
      id: 2,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.desc_3"),
          }}
        />
      ),
      icon: "amplifies",
    },
    {
      id: 3,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.overview.apart.card.desc_4"),
          }}
        />
      ),
      icon: "competence",
    },
  ];

  const {openPopup} = usePopup();

  const handleOpenPopup = () => {
    openPopup(<PresentationPopup />);
  };

  return (
    <BorderArticle>
      <div className={styles.apart_wrap}>
        <div className={styles.apart_desc}>
          <h3
            dangerouslySetInnerHTML={{
              __html: t("page.overview.apart.title"),
            }}
          />

          <p
            dangerouslySetInnerHTML={{
              __html: t("page.overview.apart.desc"),
            }}
          />

          <span
            dangerouslySetInnerHTML={{
              __html: t("page.overview.apart.subtitle"),
            }}
          />
        </div>

        <motion.ul
          initial={"hidden"}
          whileInView={"visible"}
          viewport={{amount: 0.25, once: true}}
          className={styles.apart_list}
          style={{
            "--itemHover": "linear-gradient(90deg, #B622C3 0%, #2DDEFD 100%)",
          }}
        >
          {list &&
            list.length > 0 &&
            list.map((item, index) => (
              <React.Fragment key={item.id}>
                <MApartHoverCard
                  custom={index + 1}
                  variants={!isMobile ? itemAnimation : undefined}
                  item={item}
                  index={index}
                />
              </React.Fragment>
            ))}
        </motion.ul>

        <Try
          onClickBtn={handleOpenPopup}
          title={
            <b
              dangerouslySetInnerHTML={{
                __html: t("page.overview.apart.try"),
              }}
            />
          }
        />
      </div>
    </BorderArticle>
  );
};
